import './class-branch.scss';

import { useQuery } from '@apollo/client';
import { CLASSES_BRANCH, CLASSES_BRANCH_TOTAL } from '../shared/graphql/branch';
import debounce from 'lodash.debounce';

//react
import { useState, useCallback, useEffect } from 'react';
import set from 'date-fns/set';
import format from 'date-fns/format';
//shared
import { TITLE_CLASS_BRANCH } from './constants/title';
import ClassesBranchView from './views/classes-branch-view';
import { Titles } from '../shared/components/titles/titles';
import { DaysSwiper } from '../shared/components/days-swiper/days-swiper';
import { SkeletonClassBranches } from '../shared/components/skeleton-class-branches/skeleton-class-branches';
//Material
import Grid from '@mui/material/Grid';
import Slider from '@mui/material/Slider';
import SearchIcon from '@mui/icons-material/Search';
import TakeAttendance from '../take-attendance/take-attendance';
import TextField from '@mui/material/TextField';

import Switch from '@mui/material/Switch';
import { InputAdornment } from '@mui/material';
import { ModalCancelQuotasMassive } from '../shared/components/modal-cancel-quotas-massive/modal-cancel-quotas-massive';
import { ModalActiveQuotasMassive } from '../shared/components/modal-active-quotas-massive/modal-active-quotas-massive';
import { PendingAttendance } from '../shared/components/pending-attendance/pending-attendance';

let classsesByBranch: any = []
let classsesByBranchTotal: any = []
let capacityClasses: any = [];
let page: number = 0;
export default function ClassBranch({ branch }: { branch: number }) {

    const [textSearch, setSearch] = useState<string>('');
    const [calendarSelected, changeCalendar] = useState(null);
    let [checkStudents, changeStudents] = useState(false);
    const [valueSlider, setValue] = useState<number[]>([0, 23]);
    let hasPendingAttendance = false;

    let [filters, changeFilters] = useState({
        branchId: branch,
        date: new Date().toDateString(),
        searchTerm: '',
        startTime: '',
        endTime: '',
        page: 1,
        perPage: 10,
        inscribedFrom: checkStudents ? 1 : null,
    });

    let [filtersTotal, changeFiltersTotal] = useState({
        branchId: branch,
        date: new Date().toDateString(),
        searchTerm: '',
        startTime: '',
        endTime: '',
        page: page,
        perPage: classsesByBranch.total,
        inscribedFrom: checkStudents ? 1 : null,
    });

    const classIds: number[] = [];
    const quotas: number[] = [];

    classsesByBranch = [];
    classsesByBranchTotal = [];

    useEffect(() => {
        page = 1;
        setSearch('');
        changeStudents(false);
        setValue([0, 23]);
        changeCalendar(null);

        changeFilters({
            branchId: branch,
            date: new Date().toDateString(),
            searchTerm: '',
            startTime: '',
            endTime: '',
            page: 1,
            perPage: 10,
            inscribedFrom: null,
        });

        changeFiltersTotal({
            branchId: branch,
            date: new Date().toDateString(),
            searchTerm: '',
            startTime: '',
            endTime: '',
            page: 1,
            perPage: 0,
            inscribedFrom: null,
        });

        changeDays([{}, {}, {}, {}, {}, {}, {}, {}]);
    }, [branch]);

    const { data: classesData, loading: classesLoading, fetchMore: classesFetchMore } = useQuery(CLASSES_BRANCH, { variables: filters });

    const totalClasses = classesData?.classesDayByBranchIdPaginate?.total;

    if (classesData) {
        classsesByBranch = classesData.classesDayByBranchIdPaginate;
        capacityClasses = classsesByBranch.data.map((el: any) => el.capacity);

        classsesByBranch.data.forEach((el: any) => {
            if (el.reservations && el.reservations.some((ele: any) => ele.statusId === 1)) {
                hasPendingAttendance = true;
            }
        });
    }

    useEffect(() => {
        if(totalClasses === undefined) return;

        changeFiltersTotal({
            ...filters,
            page: 1,
            perPage: totalClasses,
        });
    }, [filters, totalClasses]);

    const { data: totalClassesData, loading: totalClassesLoading = true } = useQuery(
        CLASSES_BRANCH_TOTAL, 
        {  variables: filtersTotal, skip: totalClasses === undefined }
    );

    if (totalClassesData) {
        classsesByBranchTotal = totalClassesData.classesDayByBranchIdPaginate;

        classsesByBranchTotal.data.map((clase: any) => {
            if (clase.id) {
                classIds.push(clase.id);
                quotas.push(clase.capacity);
            }

            return clase;
        });
    }

    let initialDaysArr = [{}, {}, {}, {}, {}, {}, {}, {}];
    let [days, changeDays] = useState(initialDaysArr);
    const weekdays = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
    const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

    const fetchMoreData = () => {
        page = page + 1;
        classesFetchMore({
            variables: { ...filters, page: page }, updateQuery: (previousQueryResult, { fetchMoreResult }) => {
                fetchMoreResult.classesDayByBranchIdPaginate.data = [
                    ...previousQueryResult.classesDayByBranchIdPaginate.data,
                    ...fetchMoreResult.classesDayByBranchIdPaginate.data,
                ];
                return fetchMoreResult;
            }
        });
    };

    function refreshDays(i: number) {
        let end = new Date();
        const day = new Date();
        end.setDate(end.getDate() + 15);
        const daysAux = [];

        while (day < end) {
            daysAux.push({
                date: new Date(day),
                weekDay: weekdays[new Date(day).getDay()],
                monthDay: day.getDate(),
                month: months[new Date(day).getMonth()],
                active: false,
            });
            day.setDate(day.getDate() + 1);
        }

        daysAux[i].active = true;
        const newDate = daysAux[i].date.toDateString();
        let range1: any = set(new Date(newDate), { hours: valueSlider[0], minutes: 0, seconds: 0 });
        range1 = format(range1, "yyyy-MM-dd'T'HH:mm:ss");
        let range2: any = set(new Date(newDate), { hours: valueSlider[1], minutes: 59, seconds: 59 });
        range2 = format(range2, "yyyy-MM-dd'T'HH:mm:ss");
        page = 1;

        changeFilters({
            branchId: branch,
            date: newDate,
            searchTerm: textSearch,
            startTime: range1,
            endTime: range2,
            page: 1,
            perPage: 10,
            inscribedFrom: checkStudents ? 1 : null,
        });

        changeFiltersTotal({
            branchId: branch,
            date: newDate,
            searchTerm: '',
            startTime: '',
            endTime: '',
            page: 1,
            perPage: classsesByBranch.total || 0,
            inscribedFrom: checkStudents ? 1 : null,
        });

        changeDays(daysAux);
    }

    function reload(reload: boolean) {
        page = reload ? 1 : page;
        changeFilters({
            branchId: branch,
            date: filters.date,
            searchTerm: filters.searchTerm,
            startTime: filters.startTime,
            endTime: filters.endTime,
            page: page,
            perPage: 10,
            inscribedFrom: filters.inscribedFrom,
        });

        changeFiltersTotal({
            branchId: branch,
            date: filters.date,
            searchTerm: '',
            startTime: '',
            endTime: '',
            page: page,
            perPage: classsesByBranch.total,
            inscribedFrom: checkStudents ? 1 : null,
        });
    }

    function valueLabelFormat(value: number) {
        return `${value}H`;
    }

    const callbackRange = (newValue: number[]) => {
        let range1: any = set(new Date(filters.date), { hours: newValue[0], minutes: 0, seconds: 0 });
        range1 = format(range1, "yyyy-MM-dd'T'HH:mm:ss");
        let range2: any = set(new Date(filters.date), { hours: newValue[1], minutes: 59, seconds: 59 });
        range2 = format(range2, "yyyy-MM-dd'T'HH:mm:ss");

        page = 1;
        changeFilters({
            ...filters,
            startTime: range1,
            endTime: range2,
            page: 1
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const delayedRange = useCallback(
        debounce((newValue: number[]) => callbackRange(newValue), 600),
        [filters]
    );

    const debouncedRangeChange = (event: Event, newValue: number | number[]) => {
        setValue(newValue as number[]);
        delayedRange(newValue as number[]);
    };

    const callbackSearch = (text: string) => {
        page = 1;
        changeFilters({
            ...filters,
            searchTerm: text,
            page: 1
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedSearch = useCallback(
        debounce((text) => callbackSearch(text), 600),
        [filters]
    );

    const changeSearch = (e: any) => {
        setSearch(e.target.value);
        debouncedSearch(e.target.value);
    };

    const handleClick = () => {
        const newCheckStudents = !checkStudents;
        changeStudents(newCheckStudents);
        changeFilters({
            ...filters,
            inscribedFrom: newCheckStudents ? 1 : null,
            page: 1
        });
        changeFiltersTotal({
            ...filtersTotal,
            inscribedFrom: newCheckStudents ? 1 : null,
            page: 1
        });
        page = 1;
    };

    const handleChangeTakeAttadenca = (dataCalendar: any) => {
        changeCalendar(dataCalendar)

    }
    const resetView = () => {
        classsesByBranch = [];
        classsesByBranchTotal = [];
        changeCalendar(null)
    }

    const handleAddAndCancelCuotas = (message: any) => {
        page = 1;
        changeFilters({
            branchId: branch,
            date: new Date().toDateString(),
            searchTerm: '',
            startTime: '',
            endTime: '',
            page: page,
            perPage: 10,
            inscribedFrom: checkStudents ? 1 : null,
        });
        console.log('Action:', message);
    };

    const handleEventActive = (result: any) => {
        console.log(result)
    };

    const handleEventCancel = (result: any) => {
        console.log(result)
    };

    return (
        <div className="section-menu internal-container">
            <PendingAttendance></PendingAttendance>
            <div className={`container-cards-classes ${hasPendingAttendance ? 'is-pending-attendance' : ''}  `} >
                <Titles props={TITLE_CLASS_BRANCH} />
                {calendarSelected ?
                    <TakeAttendance attendance={resetView} dataCalendar={calendarSelected}></TakeAttendance> :
                    <div>
                        <Grid container className="filters-box" >
                            <Grid item xs={4} md={4} className='container-search-bar'>
                                <TextField className="input-search" placeholder="¿Qué buscas?" onChange={changeSearch}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end" className="input-search-icon">
                                                <SearchIcon />
                                            </InputAdornment>
                                        )
                                    }} />
                            </Grid>
                            <Grid item className='button-cuotas quotas-mobile' style={{ display: 'none' }}>
                                {classsesByBranch?.data?.length !== 0 && (
                                    <>
                                        {capacityClasses.some((el: any) => el !== 0) ?
                                            <ModalCancelQuotasMassive 
                                                classIds={classIds}
                                                quotas={quotas}
                                                day={filters.date}
                                                isLoading={totalClassesLoading}
                                                onEventCancel={(result: any) => handleEventCancel(result)} />
                                            :
                                            <ModalActiveQuotasMassive
                                                classIds={classIds}
                                                quotas={quotas}
                                                day={filters.date}
                                                isLoading={totalClassesLoading}
                                                onEventActive={(result: any) => handleEventActive(result)} />
                                        }
                                    </>
                                )}
                            </Grid>
                            <Grid item xs={8} md={8} className="container-slider">
                                <Slider value={valueSlider} onChange={debouncedRangeChange} size="small"
                                    valueLabelDisplay="on" valueLabelFormat={valueLabelFormat} min={0} max={23} marks />
                            </Grid>
                        </Grid>
                        <div>
                            <Grid item xs={12} mt={5} className="container-swiper">
                                <DaysSwiper days={days} clickedDay={(i: number) => refreshDays(i)} />
                            </Grid>

                            <Grid container className='mb-05'>
                                <Grid item xs={7} className="container-switch">
                                    <label htmlFor="check-students" className="switch-label">
                                        Ver solo clases con reservas
                                    </label>
                                    <Switch id="check-students" onClick={handleClick}
                                        checked={checkStudents} />
                                </Grid>
                                <Grid item xs={5} justifyContent={'end'} className='button-cuotas quotas-desktop'>
                                    {classsesByBranch?.data?.length !== 0 && (
                                        <>
                                            {capacityClasses.some((el: any) => el !== 0) ?
                                                <ModalCancelQuotasMassive
                                                    classIds={classIds}
                                                    quotas={quotas}
                                                    day={filters.date}
                                                    isLoading={totalClassesLoading}
                                                    onEventCancel={(result: any) => handleEventCancel(result)} />
                                                :
                                                <ModalActiveQuotasMassive
                                                    classIds={classIds}
                                                    quotas={quotas}
                                                    day={filters.date}
                                                    isLoading={totalClassesLoading}
                                                    onEventActive={(result: any) => handleEventActive(result)} />
                                            }
                                        </>
                                    )}
                                </Grid>
                            </Grid>

                            {(classesLoading) && (
                                <SkeletonClassBranches />
                            )}
                            {(classsesByBranch && !classesLoading) && (
                                <ClassesBranchView
                                    dataInput={classsesByBranch}
                                    classIds={classIds}
                                    quotas={quotas}
                                    onEventAddClose={handleAddAndCancelCuotas}
                                    fetchMoreData={() => fetchMoreData()}
                                    updateData={() => reload(true)}
                                    checkBooks={(e) => handleChangeTakeAttadenca(e) }
                                    edit={false}></ClassesBranchView>
                            )}
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}